import { cn } from '@/utils/cn'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { Input } from '../common/input'
import { Label } from '../common/label'

interface PresetNameFormProps {
  id?: string
  onSubmit?: (name: string) => void
}

const CHARACTERS_LIMIT = 30

const nameSchema = z.object({
  name: z
    .string()
    .min(1, { message: 'Name cannot be empty' })
    .max(CHARACTERS_LIMIT, { message: `Name must be at most ${CHARACTERS_LIMIT} characters` }),
})

export const PresetNameForm = ({ id, onSubmit }: PresetNameFormProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    resolver: zodResolver(nameSchema),
    reValidateMode: 'onChange',
    defaultValues: { name: '' },
  })

  const onFormSubmit = handleSubmit((data: { name: string }) => {
    try {
      onSubmit?.(data.name)
    } catch (error) {
      if (error instanceof Error) {
        setError('name', { message: error.message })
      }
    }
  })

  return (
    <form id={id} className="flex flex-col gap-3" onSubmit={onFormSubmit}>
      <Label className="flex flex-col items-start gap-1">
        <span className="font-medium text-heading-foreground text-sm">Preset name</span>
        <Input
          placeholder="Enter a name"
          className={cn('h-12', errors.name && 'border-destructive hocus:border-destructive')}
          {...register('name')}
        />
      </Label>
      {errors.name && <p className="fade-in animate-in text-destructive text-xs">{errors.name.message}</p>}
    </form>
  )
}
